




































import Vue from 'vue'
import Modal from '@/components/Modal'
import { required, minLength } from 'vuelidate/lib/validators'
import { CastTemplate } from '@/types/casttemplates'
import './CreateEditCastTemplate.scss'

export default Vue.extend({
  name: 'CreateEditCastTemplate',
  props: {
    showModal: {
      type: Boolean
    },
    inputTemplate: {
      type: Object as () => CastTemplate,
    }
  },
  computed: {
    modalTitle (): string {
      return this.templateIsNew ? 'Create Event Template' : 'Edit Event Template'
    },
    templateIsNew (): boolean {
      return this.inputTemplate !== undefined && Object.keys(this.inputTemplate).length === 0
    }
  },
  watch: {
    showModal (newVal) {
      if (newVal && this.inputTemplate && this.inputTemplate.name !== undefined) {
        this.templateName = this.inputTemplate.name
      }
    }
  },
  data: () => ({
    templateName: ''
  }),
  methods: {
    formSubmitted () {
      if (!this.$v.$invalid) {
        this.$emit('submitted', this.templateName)
        this.templateName = ''
        this.hideModal()
      }
    },
    hideModal () {
      this.$emit('close')
    }
  },
  validations: {
    templateName: {
      required,
      minLength: minLength(2)
    }
  },
  components: {
    Modal
  }
})

